// extracted by mini-css-extract-plugin
export default {"overlaySearchBar":"overlaySearchBar__ODRkZ","verticallyStacked":"verticallyStacked__Y2ViY"};